import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';

import stefan from './assets/stefan.png';

import style from './ContactPage.module.less';

export const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={style.content}>
        <h1>Contact</h1>

        <div className={style.row}>
          <div className={style.text}>
            <h2>Company</h2>

            <p>
              Eleven Products Sp. z o.o. <br />
              ul. Domki 14<br />
              31-519 Kraków<br />
              Poland
            </p>

            <p>VAT: PL6793208772</p>

            <h2>Get in touch</h2>

            <p>You can reach us at <a href="mailto:contact@elevenpuzzles.com">contact@elevenpuzzles.com</a> or via <a href="https://www.facebook.com/elevenpuzzles/" target="_blank">Facebook</a> and <a href="https://www.instagram.com/elevenpuzzles/" target="_blank">Instagram</a>.</p>

            <p>We'll answer as soon as possible, however please remember that we might be in a different timezone than you - we're based in Poland and Scotland.</p>
          </div>
          <div className={style.image}>
            <img src={stefan} alt="Stefan" />
          </div>
        </div>
      </div>
    </Section>
  </Layout>
);
